export type Result<T, E> = { ok: true; value: T } | { ok: false; error: E };

export function Ok<T>(value: T): Result<T, null> {
  return { ok: true, value };
}

export function Err<E>(error: E): Result<null, E> {
  return { ok: false, error };
}

export type ResultError<R> = R extends Result<any, infer E> ? E : never;

export function isOk<T, E>(r: Result<T, E>): r is { ok: true; value: T } {
  return r.ok;
}

export function assertOk<T, E>(r: Result<T, E>): asserts r is { ok: true; value: T } {
  if (!isOk(r)) throw r.error;
}

export function assertErr<T, E>(r: Result<T, E>): asserts r is { ok: false; error: E } {
  if (isOk(r)) throw new Error(`Expected Result to be an error ${r}`);
}
